<template>
  <v-layout align-center justify-center row class="mb-12">
    <v-flex xs12 sm10 md6 text-center>
      <div>
        <h1>บริการขนส่ง</h1>
        <v-container fluid>
          <v-row dense>
            <v-col cols="6" v-for="(logistic, index) in logistics" :key="index">
              <v-card align="center" @click="goto(logistic.PL_RUNNO,logistic.PL_THNAME)" class="pa-5" height="150">
                <v-img v-if="logistic.PL_RUNNO != 16" height="110" :src="logistic.PL_IMG"
                       aspect-ratio="1.7"></v-img>
                <h1 v-else class="mt-10">อื่น ๆ</h1>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/axios";
import EventBus from '@/EventBus'

export default {
  name: "Step3",
  data() {
    return {
      logistics: {}
    }
  },
  mounted() {
    this.getLogistic()
  },
  methods: {
    goto(id, name) {
      let params = {
        id: id,
        name: name,
        step: 3
      }
      EventBus.$emit('step_submit', params)
    },
    async getLogistic() {
      try {
        axios.get("/GetLogistic").then((res) => {
          // console.log('GetLogistic',res.data.data)
          this.logistics = res.data.data
        });
      } catch (err) {
        console.log("GetLogistic", err.message);
      }
    }
  }
}
</script>

<style scoped>

</style>